import { PagerService } from './../../services/pager.service';
import { ClassBaseService } from './../../services/class-base.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonService } from 'app/services/common.service';
import { NotificationService } from './../../services/notification.service';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';
 

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent implements OnInit, OnChanges {
  @ViewChild('videosContainer') videosContainer: ElementRef;
  @Input() dynamicStudentId: any;
  @Input() studentPartnerId;
  videos = [];
  currentPage = 1; // variable to store current page
  totalItems = 0; // variable to store total items
  maxSize: number; // variable to store max size
  pageShow = false; // variable to check if pagination to be shown or not
  categories: any[];
  categoryId = '0';
  searchFilter = '';
  studentUserId: any;
  dynamicStudentUserFlag: any;
  videosRawResponse: any;
  pager: any = {};
  pagedItems: any[];
  loader = false;
  isMobileVersion;

  constructor(
    private notificationService: NotificationService,
    private loginInfoProvider: LoginInfoProvider,
    private _commonService: CommonService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _classBaseService: ClassBaseService,
    private pagerService: PagerService
  ) { }

  init() {
    const tag = document.createElement('script');
    tag.src = '//www.youtube.com/player_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  ngOnInit() {
    this.isMobileVersion = this._commonService.checkDeviceIsMobile();

    this.maxSize = this.isMobileVersion ? 5 : 50;
    this.init();
    this.studentUserId = this.loginInfoProvider.userId;

    if (!this.dynamicStudentUserFlag) {
      this.getCategoryData();
    }
  }

  ngOnChanges() {
    if (this.dynamicStudentId && this.studentPartnerId) {
      this.dynamicStudentUserFlag = true;
      this.getCategoryData();
      return;
    }

    this.dynamicStudentUserFlag = false;
  }

  getCategoryData() {
    this._classBaseService.getStudentProgessCategories(this.studentPartnerId)
      .subscribe(
        (categories) => {
          this.categories = categories;
          this.getVideoData();
        },
        () => {
          this.notificationService.show('error', 'Error while fetching category data');
        });
  }

  getVideoData() {
    const inputJson = {
      partnerId: this.studentPartnerId,
      studentUserId: this.dynamicStudentId || this.studentUserId.toString(),
      categoryClassID: this.categoryId,
      page: this.currentPage,
      pageSize: this.maxSize
    };
    this.loader = true;
    this._commonRequestResponseService.postWithHeader('Shared/videos/', inputJson, ['partnerId'])
      .subscribe(
        (videoOutputJson: any) => {
          this.loader = false;
          this.videos = videoOutputJson.items;
          this.pageShow = true;
          this.totalItems = videoOutputJson.totalItems;
          this.videosRawResponse = videoOutputJson;
          this.filterVideos();
          this.setPage(1);
          this.renderVideos();
        },
        () => {
          this.videos = [];
          this.loader = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  renderVideos() {
    setTimeout(() => {
      const iframeInstance = this.videosContainer.nativeElement.querySelectorAll('iframe');
      const videoInstance = this.videosContainer.nativeElement.querySelectorAll('video');
      this._commonService.youTubeApi(iframeInstance, videoInstance, 'video', this.videosRawResponse)
    }, 100);
  }

  filterVideos() {
    if (this.videos) {
      this.videos.forEach((video: any) => {
        video.isHidden = video.title.toLowerCase().indexOf(this.searchFilter.toLowerCase()) === -1;
        this.renderVideos();
      });
    }
  }

  pageChanged() {
    this.getVideoData();
  }

  setPage(pageNo: number) {
    this.pager = this.videos ? this.pagerService.getPager(this.videos.length, pageNo, this.maxSize) :  {};
    this.pagedItems = this.videos ? this.videos.slice(this.pager.startIndex, this.pager.endIndex + 1) : [];
    this.filterVideos();
    this.renderVideos();
  }
}
